// GENERATED FILE — do not edit. Source of truth: agents/shared/. Sync: node scripts/sync-agent-shared.mjs
// Mini JSON-Schema-subset validator — single source of truth for BOTH the
// server-side Capability Gateway and the browser dispatcher (defence in depth).
// Supported: type object|string|number|integer|boolean|array, required,
// properties, additionalProperties:false, enum, min/maxLength, minimum/maximum,
// items, min/maxItems. Every capability schema in this repo stays inside this subset.

export function validateAgainstSchema(schema, value, path = '$') {
  const errors = [];
  if (!schema || typeof schema !== 'object') return [`${path}: missing schema`];

  if (schema.type === 'any') return errors; // explicitly polymorphic (e.g. condition values)

  if (schema.type === 'object') {
    if (typeof value !== 'object' || value === null || Array.isArray(value)) {
      return [`${path}: expected object`];
    }
    const props = schema.properties ?? {};
    for (const key of schema.required ?? []) {
      if (!(key in value)) errors.push(`${path}.${key}: required`);
    }
    for (const [key, v] of Object.entries(value)) {
      if (!(key in props)) {
        if (schema.additionalProperties === false) {
          errors.push(`${path}.${key}: additional property not allowed`);
        }
        continue;
      }
      errors.push(...validateAgainstSchema(props[key], v, `${path}.${key}`));
    }
    return errors;
  }

  if (schema.type === 'array') {
    if (!Array.isArray(value)) return [`${path}: expected array`];
    if (schema.minItems != null && value.length < schema.minItems) {
      errors.push(`${path}: fewer than ${schema.minItems} items`);
    }
    if (schema.maxItems != null && value.length > schema.maxItems) {
      errors.push(`${path}: more than ${schema.maxItems} items`);
    }
    if (schema.items) {
      value.forEach((v, i) => errors.push(...validateAgainstSchema(schema.items, v, `${path}[${i}]`)));
    }
    return errors;
  }

  if (schema.type === 'string') {
    if (typeof value !== 'string') return [`${path}: expected string`];
    if (schema.enum && !schema.enum.includes(value)) {
      errors.push(`${path}: must be one of ${schema.enum.join(', ')}`);
    }
    if (schema.maxLength != null && value.length > schema.maxLength) {
      errors.push(`${path}: longer than ${schema.maxLength} characters`);
    }
    if (schema.minLength != null && value.length < schema.minLength) {
      errors.push(`${path}: shorter than ${schema.minLength} characters`);
    }
    return errors;
  }

  if (schema.type === 'number' || schema.type === 'integer') {
    if (typeof value !== 'number' || Number.isNaN(value)) return [`${path}: expected number`];
    if (schema.type === 'integer' && !Number.isInteger(value)) errors.push(`${path}: expected integer`);
    if (schema.enum && !schema.enum.includes(value)) errors.push(`${path}: must be one of ${schema.enum.join(', ')}`);
    if (schema.minimum != null && value < schema.minimum) errors.push(`${path}: below minimum ${schema.minimum}`);
    if (schema.maximum != null && value > schema.maximum) errors.push(`${path}: above maximum ${schema.maximum}`);
    return errors;
  }

  if (schema.type === 'boolean') {
    if (typeof value !== 'boolean') return [`${path}: expected boolean`];
    return errors;
  }

  return [`${path}: unsupported schema type ${String(schema.type)}`];
}

export const objectSchema = (properties, required = []) => ({
  type: 'object',
  required,
  additionalProperties: false,
  properties,
});
